
		export default class PageState{
			//模板生成============================================================================
			self:any = null;
			title: string = "";
			ww_token: string = ""
			vipInfo: any = '';
			loading:boolean = false;
			finished:boolean = false;
			refreshing:boolean = false;
			source:string = ""
			//============================================================================
		}
